// Module
var code = "<react-component name=\"AllEventsReport\"></react-component>\n";
// Exports
module.exports = code;